export default "/images/3d58aa84ca70cd443a244182a9b80142.avif";